import { useEffect } from 'react';

import { ADMIN_PUSH_SENT, type AdminPushSentDetail } from 'services/notifications.service';
import { showDesktopPushNotification } from 'utils/desktopPushNotification';

export default function AdminPushDesktopListener() {
  useEffect(() => {
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent<AdminPushSentDetail>).detail;
      const entry = detail?.entry;
      if (!entry) return;
      const body = entry.bodyPreview?.trim() || 'Push request was accepted by the server.';
      showDesktopPushNotification(entry.title, body, { tag: `admin-push-${entry.notificationId}` });
    };
    window.addEventListener(ADMIN_PUSH_SENT, handler);
    return () => window.removeEventListener(ADMIN_PUSH_SENT, handler);
  }, []);
  return null;
}
